import type { ReactNode } from 'react'

import { cn } from '@/shared/lib/utils'

import { CATALOG_LIST_CARD_BODY_CLASS, CATALOG_LIST_CARD_FOOTER_CLASS } from './catalogListCardShell'

type CatalogListCardBodyProps = {
  className?: string
  children: ReactNode
}

export function CatalogListCardBody({ className, children }: CatalogListCardBodyProps) {
  return <div className={cn(CATALOG_LIST_CARD_BODY_CLASS, className)}>{children}</div>
}

/** @deprecated 请用 CatalogListCardContent / CatalogListCardViewDetail */
export function CatalogListCardFooter({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={cn(CATALOG_LIST_CARD_FOOTER_CLASS, className)}>{children}</div>
}
